import { ApiResponse, ApiStatus } from "../models/api-response";
import { PluginConfig } from "../models/plugin-config";
import { User } from "../models/user";
import { getISO3LangCode } from "../utils/helpers";

export async function fetchUserData(config: PluginConfig, bookingDomain: string | undefined): Promise<ApiResponse<User>> {
  const url = `${bookingDomain}api/club/user-basic-details?chainId=${config.chainId}&lang=${getISO3LangCode(config.language)}`;

  const response = await fetch(url, { credentials: 'include' });

  if (!response.ok) return { Data: { Name: '', LoggedIn: false }, Status: ApiStatus.Error };
  return response.json();
}